// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__OJY4t","winter":"AboutUs_winter__0mOHo","summer":"AboutUs_summer__dZZmv","img":"AboutUs_img__FYvmG"};